/**
 * Ticked rows on the Agents and Vendors lists, the way the Properties list
 * keeps them: the header box ticks the page, the selection survives paging
 * and re-sorting, and any other change to the filter is a different list and
 * empties it. Only ids are kept — the mail merge looks the people up again.
 */

/** SortTable draws a checkbox column for a first column with an empty name. */
export const CHECKBOX_COLUMN = { name: '', render: (el) => el };

/**
 * Identity of the list a selection was made against: the query without
 * `page` and `order`, which show other rows of the same list.
 */
export function selectionSignature(query) {
    const filters = { ...(query || {}) };
    delete filters.page;
    delete filters.order;

    return JSON.stringify(Object.keys(filters).sort().map((key) => [key, filters[key]]));
}

/** The rows with SELECTED set from the running selection. */
export function markSelected(items, selectedIds) {
    return (items || []).map((item) => ({
        ...item,
        SELECTED: selectedIds.has(String(item.ARCIMEDES_ROW_ID)),
    }));
}

/**
 * Applies a SortTable checkbox click: `name` is the row's index, or
 * 'selectAll' for the header box, whose `checked` is its state before the
 * click. Rows on other pages keep their ticks.
 *
 * @returns {{items: object[], selectedIds: Set<string>}}
 */
export function toggleSelection(items, selectedIds, name, checked) {
    const next = new Set(selectedIds);

    const rows = (items || []).map((item, index) => {
        const id = String(item.ARCIMEDES_ROW_ID);
        let selected = next.has(id);

        if (name === 'selectAll') {
            selected = !checked;
        } else if (index === name) {
            selected = !selected;
        }

        if (selected) next.add(id); else next.delete(id);

        return { ...item, SELECTED: selected };
    });

    return { items: rows, selectedIds: next };
}

/** How many of the rows on screen are ticked. */
export function pageSelectedCount(items) {
    return (items || []).filter((item) => item.SELECTED).length;
}
